<script>
	import Layout from 'components/Layout.svelte';
</script>

<Layout title="Privacy Policy">
	<h1>Privacy Policy</h1>
	<p>
		Your privacy is important to us. It is Somerset County 4‑H Fair App's policy to respect your
		privacy regarding any information we may collect from you across our website,
		<a href="/">sc4hfair</a>.
	</p>
	<p>
		We only ask for personal information when we need it to provide services to you. We collect it
		by fair and lawful means, with your knowledge and consent. We also let you know why we're
		collecting it and how it will be used.
	</p>
	<p>
		If you create an account, your name, email address, and profile picture (from the external
		account you use to create it) will be stored. Accounts are grouped by email address, so
		different providers that share the same email address will always sign you in to the same
		account. Additional user provided information may be managed in the
		<a href="/settings">user settings</a>.
	</p>
	<p>
		Each page contains a client-side script that keeps track of your navigation through our site. We
		collect data about the time of viewing, the device you viewed the page on, how many pages you
		have viewed, as well as your progression from page to page. We identify who you are through an
		anonymous tracking ID (generated the first time you view our site), and we do not track you
		across other websites. We also track in real time if you are currently viewing the app and your
		progress through the <a href="/scavenger-hunt">scavenger hunt</a>.
	</p>
	<p>
		The notifications feature is opt-in, and you can unsubscribe your device at any point in the
		<a href="/settings#notifications">app settings</a>. Only the previous anonymous tracking ID
		information and Web Push authorization information is stored while subscribed.
	</p>
	<p>
		We'll protect any data we store within commercially acceptable means to prevent loss and theft,
		as well as unauthorized access, disclosure, copying, use or modification.
	</p>
	<p>
		We don't share any personally identifying information publicly or with third-parties besides
		<a href="https://4histops.org">Somerset County 4‑H</a>, except when required to by law. If you
		use the
		<a href="/interests">club interest manager</a>, your provided name, email address, phone number,
		and other relavent information will be shared with leaders of the clubs you marked as interested
		in.
	</p>
	<p>
		Our website may link to external sites that are not operated by us. Please be aware that we have
		no control over the content and practices of these sites, and cannot accept responsibility or
		liability for their respective privacy policies.
	</p>
	<p>
		Your continued use of our website will be regarded as acceptance of our practices around privacy
		and personal information. If you have any questions about how we handle user data and personal
		information, feel free to <a href="/feedback">contact us</a>.
	</p>
	<p>This policy was last updated and effective as of April 6, 2024.</p>
</Layout>
